import React, { useState, useEffect } from "react";
import http from "./../../Services/http";
import FoodItem from "../FoodItem/FoodItem";
import Loader from "react-loader-spinner";
import "./Foods.css";

const Foods = ({ user }) => {
  const [foods, setFoods] = useState();
  // const [loader, setLoader] = useState();
  useEffect(() => {
    const fetchFoods = async () => {
      const { data } = await http.get("/foods");
      setFoods(data.foods);
    };

    fetchFoods();
  }, []);

  if (!foods)
    return <Loader type="ThreeDots" color="#ef92c8" height={200} width={200} />;

  return (
    <div className="foods">
      {foods.length === 0
        ? "not foods found"
        : foods.map((food) => (
            <FoodItem key={food._id} food={food} user={user} />
          ))}
    </div>
  );
};

export default Foods;
